import styled from "styled-components";

export const Title = styled.h2`
  font-size: 18px;
  margin: 0 0 8px;
  user-select: none;
`;

// One column of full-width buttons, spaced by the gap alone.
export const CancelWrapper = styled.div`
  background-color: ${({ theme }) => theme.surface};
  margin: auto;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 40px;
  text-align: center;
`;

// "Do not leave" sits apart, under a divider.
export const NotLeave = styled.div`
  margin-top: 8px;
  padding-top: 20px;
  border-top: 1px solid ${(props) => props.theme.divider};
`;
